export enum ErrorConstants {
    expiredSession = 'EXPIRED_SESSION',
}
